import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import SearchByVehicleSimpleForm from '../../../components/search/SearchByVehicleSimpleForm'
import { translate } from 'react-polyglot'
import { resetFilters } from '../../../actions/search/search'

export function mapStateToProps (state) {
  return {
  }
}

export function mapDispatchToProps (dispatch) {
  return {
    actions: bindActionCreators({
      resetFilters
    }, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(translate()(SearchByVehicleSimpleForm))
